module.exports = __webpack_public_path__ + "img/pr-15.e82c3568.png";